import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ciceroConfig } from "./data";

export default function CiceroPage() {
  return <CityPageTemplate config={ciceroConfig} />;
}